'use strict';

function pushAddToCartToSnapchat(snapchatKey, userEmail) {
    snaptr('init', snapchatKey,{'user_email': userEmail});
    snaptr('track','ADD_CART');
}

function pushAddToCartToTikTok(mainPrice) {
    if (typeof ttq !== 'undefined') {
        ttq.track('AddToCart', {
            value: mainPrice,
            currency: 'CAD',
        });
    }
}

function pushOrderConfirmationToSnapchat(snapchatKey, userEmail, totalPrice, confirmationNumber) {
    snaptr('init', snapchatKey, { 'user_email': userEmail });
    snaptr('track', 'PURCHASE', { 'currency': 'CAD', 'price': totalPrice,'transaction_id': confirmationNumber });
}

function pushOrderConfirmationToTikTok(totalPrice) {
    if (typeof ttq !== 'undefined') {
        ttq.track('Purchase', {
            value: totalPrice,
            currency: 'CAD',
        });
    }
}